module.exports = __webpack_public_path__ + "static/media/grila.8b103012.jpg";